module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalSeleccionarDocumentosFirmar) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('seleccionar-documentos-firmar', {
    attrs: {
      "idEmpleado": +_vm.codigoEmpleadoInterno
    },
    on: {
      "close": _vm.closeModalSeleccionarDocumentosFirmar
    }
  })], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalListaLibrosVacaciones) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "box position-relative"
  }, [_c('component-lista-libros-vacaciones', {
    attrs: {
      "codigoEmpleado": +_vm.codigoEmpleadoInterno
    },
    on: {
      "close": _vm.closeModalListaLibrosVacaciones
    }
  })], 1)]) : _vm._e()]), _c('div', {
    staticClass: "modal-card card w-942"
  }, [_c('div', {
    staticClass: "modal-card-head flex"
  }, [_vm._m(0), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.close
    }
  })]), _c('div', {
    staticClass: "card-content card-content-max"
  }, [_c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Datos")]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex fd-c-datos"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Codigo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.codigo),
      expression: "empleado.codigo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.empleado.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "codigo", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Nombre")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.nombre),
      expression: "empleado.nombre"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "nombre", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Perfil")]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.perfilVacaciones),
      expression: "empleado.perfilVacaciones"
    }],
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.empleado, "perfilVacaciones", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "usuario"
    }
  }, [_vm._v("Usuario")]), _c('option', {
    attrs: {
      "value": "jefe"
    }
  }, [_vm._v("Jefe")]), _c('option', {
    attrs: {
      "value": "recursos humanos"
    }
  }, [_vm._v("Recursos Humanos")])])])])]), _c('div', {
    staticClass: "flex fd-c-datos"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Usuario")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.usuario),
      expression: "empleado.usuario"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "usuario", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Cargo")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.cargo),
      expression: "empleado.cargo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading,
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.empleado.cargo)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaCargo = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "cargo", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaCargo = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.empleado.cargo = ''
      }
    }
  }, [_vm._m(1)])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaCargo) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-cargo', {
    on: {
      "selected": _vm.seleccionarCargo,
      "close": function($event) {
        _vm.mostrarBusquedaCargo = false
      }
    }
  })], 1) : _vm._e()])], 1), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.email),
      expression: "empleado.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "email", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "flex position-relative fd-c-datos"
  }, [_c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Codigo Jefe")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.codigoJefe),
      expression: "empleado.codigoJefe"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.codigoJefe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "codigoJefe", $event.target.value)
      }
    }
  }), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaJefe = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": function($event) {
        _vm.empleado.codigoJefe = ''
      }
    }
  }, [_vm._m(2)])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaJefe) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-small-empleado', {
    attrs: {
      "codigo": _vm.empleado.codigoJefe,
      "tipo": 'jefe'
    },
    on: {
      "selected": _vm.seleccionarJefe,
      "close": function($event) {
        _vm.mostrarBusquedaJefe = false
      }
    }
  })], 1) : _vm._e()])], 1), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("DNI")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.dni),
      expression: "empleado.dni"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.dni)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "dni", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Régimen")]), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.regimen),
      expression: "empleado.regimen"
    }],
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.empleado, "regimen", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "general"
    }
  }, [_vm._v("General")]), _c('option', {
    attrs: {
      "value": "pyme"
    }
  }, [_vm._v("PYME")])])])])]), _c('div', {
    staticClass: "flex position-relative fd-c-datos"
  }, [_c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Fecha Nacimiento")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.fechaNacimiento),
      expression: "empleado.fechaNacimiento"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.fechaNacimiento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "fechaNacimiento", $event.target.value)
      }
    }
  })])]), (_vm.empresa !== 'raymisa') ? _c('div', {
    staticClass: "control flex-1 title-singular"
  }, [_c('p', [_vm._v("Area")]), _c('div', {
    staticClass: "input-container"
  }, [(!_vm.empleado.idArea) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.idArea),
      expression: "empleado.idArea"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading,
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.empleado.idArea)
    },
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "idArea", $event.target.value)
      }
    }
  }) : _c('div', {
    staticClass: "item fdc flex-1"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.nombreArea)))]), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.nombreGerencia))])]), _c('span', {
    staticClass: "icon cursor-pointer margin-left-5",
    on: {
      "click": function($event) {
        _vm.mostrarBusquedaArea = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('div', {
    staticClass: "erase-data",
    on: {
      "click": _vm.borrarArea
    }
  }, [_vm._m(3)])]), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarBusquedaArea) ? _c('div', {
    staticClass: "pop-over"
  }, [_c('lookup-area', {
    on: {
      "selected": _vm.seleccionarArea,
      "close": function($event) {
        _vm.mostrarBusquedaArea = false
      }
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _c('div', {
    staticClass: "control flex title-singular fdc space-evenly"
  }, [_c('button', {
    staticClass: "button is-small is-primary m-5 select-doc",
    on: {
      "click": _vm.openModalSeleccionarDocumentosFirmar
    }
  }, [_vm._m(4), _vm._m(5)])])]), _c('div', {
    staticClass: "flex position-relative fd-c-datos"
  }, [_c('div', {
    staticClass: "control flex title-singular fdc space-evenly"
  }, [_c('button', {
    staticClass: "button is-small is-success has-text-bold m-5",
    on: {
      "click": _vm.verLibroDeVacaciones
    }
  }, [_vm._m(6), _c('span', [_vm._v("Ver libro de vacaciones")])])])])])]), _c('section', {
    staticClass: "padding-top-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Contrato")]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex fd-c-contrato"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Fecha Ingreso")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.fechaIngreso),
      expression: "empleado.fechaIngreso"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "disabled": _vm.codigoEmpleadoInterno > 0
    },
    domProps: {
      "value": (_vm.empleado.fechaIngreso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "fechaIngreso", $event.target.value)
      }
    }
  })]), _c('div', {
    key: "tiene-contrato-indefinido",
    staticClass: "control"
  }, [_c('p', [_vm._v("¿Contrato indefinido?")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.contratoIndeterminado === 1
    },
    on: {
      "click": function($event) {
        _vm.empleado.contratoIndeterminado = 1
      }
    }
  }, [_c('span', [_vm._v("Si")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.contratoIndeterminado === 0
    },
    on: {
      "click": function($event) {
        _vm.empleado.contratoIndeterminado = 0
      }
    }
  }, [_c('span', [_vm._v("No")])])])]), (_vm.empleado.contratoIndeterminado === 0) ? _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Fecha fin contrato")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.fechaFinContrato),
      expression: "empleado.fechaFinContrato"
    }],
    staticClass: "input",
    attrs: {
      "type": "date",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.fechaFinContrato)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "fechaFinContrato", $event.target.value)
      }
    }
  })]) : _vm._e()])])]), _c('section', {
    staticClass: "padding-top-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Pensión")]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex fd-c-pension"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Tipo Pension")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.tipoPension),
      expression: "empleado.tipoPension"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.tipoPension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "tipoPension", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("AFP Codigo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.afpCodigo),
      expression: "empleado.afpCodigo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.afpCodigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "afpCodigo", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("AFP Nombre")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.afpNombre),
      expression: "empleado.afpNombre"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.afpNombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "afpNombre", $event.target.value)
      }
    }
  })])])])]), _c('section', {
    staticClass: "padding-top-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Sueldo")]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex fd-c-sueldo"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Cuenta Sueldo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.sueldoCuenta),
      expression: "empleado.sueldoCuenta"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.sueldoCuenta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "sueldoCuenta", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Codigo Banco Sueldo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.sueldoCodigoBanco),
      expression: "empleado.sueldoCodigoBanco"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.sueldoCodigoBanco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "sueldoCodigoBanco", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Banco Sueldo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.sueldoNombreBanco),
      expression: "empleado.sueldoNombreBanco"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.sueldoNombreBanco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "sueldoNombreBanco", $event.target.value)
      }
    }
  })]), _c('div', {
    key: "moneda-sueldo",
    staticClass: "control"
  }, [_c('p', [_vm._v("Moneda sueldo")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.sueldoMoneda === 'soles'
    },
    on: {
      "click": function($event) {
        _vm.empleado.sueldoMoneda = 'soles'
      }
    }
  }, [_c('span', [_vm._v("S/")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.sueldoMoneda === 'dolares'
    },
    on: {
      "click": function($event) {
        _vm.empleado.sueldoMoneda = 'dolares'
      }
    }
  }, [_c('span', [_vm._v("USD")])])])])])])]), _c('section', {
    staticClass: "padding-top-10"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("CTS")]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flex fd-c-cts"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("CTS cuenta")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.ctsCuenta),
      expression: "empleado.ctsCuenta"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.ctsCuenta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "ctsCuenta", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Codigo Banco CTS")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.ctsCodigoBanco),
      expression: "empleado.ctsCodigoBanco"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.ctsCodigoBanco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "ctsCodigoBanco", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Banco CTS")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empleado.ctsNombreBanco),
      expression: "empleado.ctsNombreBanco"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.empleado.ctsNombreBanco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.empleado, "ctsNombreBanco", $event.target.value)
      }
    }
  })]), _c('div', {
    key: "moneda-cts",
    staticClass: "control"
  }, [_c('p', [_vm._v("Moneda CTS")]), _c('div', {
    staticClass: "opciones"
  }, [_c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.ctsMoneda === 'soles'
    },
    on: {
      "click": function($event) {
        _vm.empleado.ctsMoneda = 'soles'
      }
    }
  }, [_c('span', [_vm._v("S/")])]), _c('div', {
    staticClass: "opcion",
    class: {
      'active': _vm.empleado.ctsMoneda === 'dolares'
    },
    on: {
      "click": function($event) {
        _vm.empleado.ctsMoneda = 'dolares'
      }
    }
  }, [_c('span', [_vm._v("USD")])])])])])])])]), _c('footer', {
    staticClass: "modal-card-foot flex padding-5"
  }, [(_vm.codigoEmpleadoInterno === 0 || (_vm.empleado.codigo > 0 && _vm.empleado.activo === 1)) ? _c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardarEmpleado
    }
  }, [(_vm.isLoading) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]) : _vm._e(), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.close
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])]), (_vm.mostrarObservaciones) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.mostrarObservaciones
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeModalObservaciones),
      expression: "closeModalObservaciones"
    }],
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_c('span', [_vm._v("Observaciones encontradas")])]), _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.closeModalObservaciones
    }
  })])])]), _c('div', {
    staticClass: "card-content card-content-observaciones-max-height"
  }, [_c('div', {
    staticClass: "content has-text-left"
  }, _vm._l((_vm.observaciones), function(o) {
    return (_vm.observaciones.length > 0) ? _c('div', [_c('strong', [_vm._v(_vm._s(o))])]) : _vm._e()
  }), 0)]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "button card-footer-item is-primary is-outlined info-box-button",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.closeModalObservaciones
    }
  }, [_vm._v("Cancelar")])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Datos del Empleado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', [_vm._v("Seleccionar")]), _c('br'), _c('span', [_vm._v("documentos")]), _c('br'), _c('span', [_vm._v("por firmar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-eye is-small"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ca04e98","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Empleado_Editar.vue
// module id = 775
// module chunks = 0